export default __webpack_public_path__ + "images/vg-7bc5c83294392b4386af3792418872b1.svg";